import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_EMPLOYEE_PROGRAM_BACKFILL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_EMPLOYEE_PROGRAM_BACKFILL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_EMPLOYEE_PROGRAM_BACKFILL_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/employee-programs/${id}/backfill`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
